import { CutInfo, CutInfoBox, CutInfoHeader, IconHover } from './Sidebar.styles';
import Modal from 'components/Modal/Modal';
import useModal from 'components/Modal/useModal';
import EditCutForm from 'components/Form/EditCutForm';
import Row from 'components/Grid/Row';
import { useRef } from 'react';
import { cutStepDetails } from '../cutStepDetails';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { regular, solid } from '@fortawesome/fontawesome-svg-core/import.macro';

function CutInfoContainer({ cut, refreshCuts, setLoading }) {
    const {isShowing, toggleModal} = useModal();

    //Colors for headers
    let headerStyle = {background: '#2da322'};
    let orderDate = cut?.project?.orderDate;

    // function isMoreThanNDaysAgo(orderDate, days, lessThan = false) {
    //     const transformedDate = new Date(orderDate);
    //     //                   days  hours min  sec  ms
    //     const thirtyDaysInMs = days * 24 * 60 * 60 * 1000;
    //     const timestampThirtyDaysAgo = new Date().getTime() - thirtyDaysInMs;

    //     if (lessThan) {
    //         return timestampThirtyDaysAgo < transformedDate;
    //     }

    //     return timestampThirtyDaysAgo > transformedDate;
    // }

    let latestStep = '';

    if (cut.steps.length === 0){
        const step = cutStepDetails[0];
        headerStyle = {background: step.color};
        latestStep = step.label;
    } else if (cut.steps.length === 1) {
        const step = cutStepDetails[1];
        headerStyle = {background: step.color};
        latestStep = step.label;
    } else if (cut.steps.length === 2) {
        if (cut.product.name === 'Concrete') {
            const step = cutStepDetails[3];
            headerStyle = {background: step.color, color: '#fff'};
            latestStep = step.label;
        } else {
            const step = cutStepDetails[2];
            headerStyle = {background: step.color, color: '#fff'};
            latestStep = step.label;
        }      
    }

    if (cut.product.name === "Asphalt" && cut.steps.length === 3){
        const step = cutStepDetails[4];
        headerStyle = {background: step.color, color: '#fff'};
        latestStep = step.label;
    }

    const formattedDate = new Date(orderDate).toLocaleDateString('en-us', { timeZone:'UTC', year:"numeric", month:"long", day:"numeric"});

    // Scroll to success message when form submitted
    const modalRef = useRef(null);

    const scrollTop = () => {
        modalRef.current.scrollIntoView();
    }

    // if (isMoreThanNDaysAgo(orderDate, 30) && latestStep === "Complete") {
    //     return null;
    // }

    const hasValidDimensions = (length, width, depth) => {
        return [length, width, depth].some(val => typeof val === 'number' && val > 0);
    };

    const safeValue = (val) => (typeof val === 'number' ? val : 0);

    return (
        <CutInfoBox>
            <CutInfoHeader style={headerStyle}>
                {cut.address} {cut.street} - {cut.product.name}
                <IconHover>
                    <FontAwesomeIcon icon={regular('pen-to-square')} onClick={toggleModal} />
                </IconHover>
                <Modal isShowing={isShowing} hide={toggleModal} title="Edit Entry" modalRef={modalRef}>
                    <EditCutForm cut={cut} formattedDate={formattedDate} latestStep={latestStep} refreshCuts={refreshCuts} setLoading={setLoading} toggleModal={toggleModal} scrollTop={scrollTop}/>
                </Modal>
            </CutInfoHeader>
            <CutInfo>
                <Row>
                    <FontAwesomeIcon icon={regular('calendar')} style={{marginRight:"7px"}} />{formattedDate}
                    <FontAwesomeIcon icon={solid('user')} style={{marginRight:"7px", marginLeft:"15px"}} />{cut?.project?.client?.name}
                </Row>
            </CutInfo>
            {/* {latestStep === "View" && (
                <CutInfo>
                    <FontAwesomeIcon icon={solid('eye')} style={{marginRight:"7px"}} />{latestStep}
                </CutInfo>
            )} */}
            {latestStep === "Digout" && (
                <CutInfo>
                    <FontAwesomeIcon icon={solid('person-digging')} style={{marginRight:"7px"}} />{latestStep}
                </CutInfo>
            )}
            {latestStep === "Base" && (
                <CutInfo>
                    <FontAwesomeIcon icon={solid('mound')} style={{marginRight:"7px"}} />{latestStep}
                </CutInfo>
            )}
            {latestStep === "Surface" && (
                <CutInfo>
                    <FontAwesomeIcon icon={solid('truck')} style={{marginRight:"7px"}} />{latestStep}
                </CutInfo>
            )}
            {latestStep === "Crack Fill" && (
                <CutInfo>
                    <FontAwesomeIcon icon={solid('trash-check')} style={{marginRight:"7px"}} />{latestStep}
                </CutInfo>
            )}
            {/* {latestStep === "Complete" && (
                <CutInfo>
                    <FontAwesomeIcon icon={regular('square-check')} style={{marginRight:"7px"}} />{latestStep}
                </CutInfo>
            )} */}
            {cut.product.name !== 'Additional Work' && hasValidDimensions(cut.originalLength, cut.originalWidth, cut.originalDepth) && (
                <CutInfo>
                    <h6>Original:</h6>
                    {safeValue(cut.originalLength)} in. x {safeValue(cut.originalWidth)} in. x {safeValue(cut.originalDepth)} in.
                </CutInfo>
            )}
            {cut.product.name !== 'Additional Work' && hasValidDimensions(cut.actualLength, cut.actualWidth, cut.actualDepth) && (
                <CutInfo>
                    <h6>Actual:</h6>
                    {safeValue(cut.actualLength)} in. x {safeValue(cut.actualWidth)} in. x {safeValue(cut.actualDepth)} in.
                </CutInfo>
            )}
            {cut.comments && (
                <CutInfo>
                    <h6>Comments:</h6>
                    {cut.comments}
                </CutInfo>
            )}
        </CutInfoBox>
    );
}

export default CutInfoContainer;
